import { MakeQueryString } from 'front-utility';
import { ApiRoute } from 'api-base-refrence';
import { NestjsPageFilter } from 'nestjs-model-utility';
import { InformationApiRoute } from './information.api';
import { InformationModel } from 'src/domains/charts/model/information/information.model';

export class AverageEngagementClvFilterApiRoute extends ApiRoute {
  static apiName = '';
  static parent = InformationApiRoute;
  static urlPattern(
    filter?: NestjsPageFilter<keyof InformationModel.averageEngagement> & {
      date: string;
    },
  ) {
    return `/average-engagement-clv?${MakeQueryString(filter)}`;
  }
}
